import type { TestContext, TestFunction } from 'yup';

import { validateInnBySum } from './validateInnBySum';

export const isCorrectInn: TestFunction<string | undefined> = (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const inn = String(value).replace(/\D/g, '');
  if (!inn) {
    return false;
  }
  if (![10, 12].includes(inn.length)) {
    return context.createError({ path: context.path, message: 'Номер ИНН - 10 или 12 символов' });
  }
  const isValid = validateInnBySum(inn);
  return isValid || context.createError({ path: context.path, message: 'Недействительный ИНН организации' });
};
